import type { BoggleBadgeProgressProjection } from '~/boggle/progress/types'
import type { BoggleUnviewedBadge } from '~/boggle/progress/types'
import { loadBoggleCompendiumProgress } from '~/boggle/ui/compendium/loadBoggleCompendiumProgress'

export type CompendiumHubSession = {
  progress: BoggleBadgeProgressProjection
  sessionUnviewedBadges: readonly BoggleUnviewedBadge[]
}

type CompendiumHubRepository = {
  acknowledgeUnviewedBadges(): Promise<readonly BoggleUnviewedBadge[]>
  getUnviewedBadges(): Promise<BoggleUnviewedBadge[]>
}

/** Loads compendium progress, snapshots durable unviewed badges, then acknowledges them. */
export async function bootstrapCompendiumHubSession(
  repository: CompendiumHubRepository,
): Promise<CompendiumHubSession> {
  const [progress, unviewedBadges] = await Promise.all([
    loadBoggleCompendiumProgress(),
    repository.getUnviewedBadges(),
  ])
  await repository.acknowledgeUnviewedBadges()
  return { progress, sessionUnviewedBadges: unviewedBadges }
}
